<template>
  <section class="content">
    <div class="box box-info">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <a href="#" @click.prevent="exportCSV()" v-if="this.bankClosingBalInludingOverDraftList.length > 0">
            <img src="../../../../static/img/excel.png" style="float: right;height: 3em;width: 3em;"/>
          </a>
          <!-- DataTable for PartyStatement -->

          <DataTable :value="bankClosingBalInludingOverDraftList"
                     class="p-datatable-responsive-demo p-datatable-gridlines"
                     :rowsPerPageOptions="[100,500,1000]"
                     :rows="100" :filters="filters"
                     data-key="id">
            <template #empty>No record found</template>
            <Column header="S.N"></Column>
            <Column header="Bank Name" field="name">
            </Column>
            <Column :sortable="true" header="Account Number" field="accountNumber"/>
            <Column :sortable="true" header="Account Type" field="type"/>
            <Column :sortable="true" header="Branch" field="branch"/>
            <Column :sortable="true" header="Closing Balance" bodyStyle="text-align: right"
                    field="closingBalance"/>
            <Column :sortable="true" header="Dr-Cr" bodyStyle="text-align: right"
                    field="drCr"/>
<!--            <template #footer>-->
<!--              &lt;!&ndash; Total:{{calculateTotal()}} &ndash;&gt;-->
<!--            </template>-->
          </DataTable>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default {
  data() {
    return {
      bankClosingBalInludingOverDraftList: []
    }
  },
  mounted() {
    this.searchBankClosingInludingOverDraft()
  },
  methods: {
    async searchBankClosingInludingOverDraft() {
      let response = await this.$store.dispatch('bankClosingIncludingOverDraft')
      this.bankClosingBalInludingOverDraftList = response.data.data
    }
    // calculateTotal() {
    //   let total = 0
    //   // debugger
    //   for (let bcdInc of this.bankClosingBalInludingOverDraftList) {
    //     total += bcdInc.closingBalance
    //     // debugger
    //     console.log(total)
    //   }
    // }
  },
  components: {
    DataTable,
    Column
  }
}
</script>



// WEBPACK FOOTER //
// bankClosingBalIncludingOverDraft.vue?c5797d46